module.exports = __webpack_public_path__ + "img/rtb_silo_3.c630703d.png";